// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__1seaE","list":"styles_list__f9qhN","link":"styles_link__1Wajs","active":"styles_active__38Pkk"};